export default __webpack_public_path__ + "static/media/about.4dd7930b.jpg";